import { BackgroundThemeRevision } from 'referral-types';
import CrosshatchCubesBackground from './subthemes/CrosshatchCubes';
import DualRipplesBackground from './subthemes/DualRipples';

enum SubThemes {
  CrosshatchCubesBackground = 'crosshatch-cubes',
  DualRipples = 'dual-ripples',
}

export const GeometricSubThemeOptions = [
  { value: SubThemes.DualRipples, label: 'Dual Ripples' },
  { value: SubThemes.CrosshatchCubesBackground, label: 'Crosshatch Cubes' },
];

export const GeometricBackgrounds = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  const subTheme = themeRevision?.subTheme || SubThemes.DualRipples;
  switch (subTheme as SubThemes) {
    case SubThemes.DualRipples:
      return <DualRipplesBackground {...props} />;
    case SubThemes.CrosshatchCubesBackground:
      return <CrosshatchCubesBackground {...props} />;
    default:
      return <CrosshatchCubesBackground {...props} />;
  }
};
